import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input", "validationMessage"];

  connect() {
    this.element.dataset.formValid = "false";
  }

  validateField(event) {
    const input = event.target;
    let isValid = false;
    let message = "";

    switch (input.name) {
      case "user[email]":
        isValid = this.validateEmail(input.value);
        message = isValid ? "" : "Please enter a valid email address";
        break;
      case "user[username]":
        isValid = this.validateUsername(input.value);
        message = isValid ? "" : "Username must be at least 3 characters long";
        break;
      case "user[password]":
        const strength = this.getPasswordStrength(input.value);
        isValid = strength >= 3;
        message = isValid ? "" : "Password should be stronger";
        this.updatePasswordStrengthUI(strength);
        break;
    }

    this.showValidation(input, isValid, message);
    this.updateFormValidity();
  }

  validateUsername(username) {
    return username.length >= 3;
  }

  validateEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  getPasswordStrength(password) {
    let strength = 0;
    if (password.length >= 8) strength++;
    if (/[a-z]/.test(password)) strength++;
    if (/[A-Z]/.test(password)) strength++;
    if (/[0-9]/.test(password)) strength++;
    if (/[^A-Za-z0-9]/.test(password)) strength++;
    return strength;
  }

  updatePasswordStrengthUI(strength) {
    const strengthBar = this.element.querySelector('.strength-bar');
    const strengthText = this.element.querySelector('.strength-text');
    
    if (strengthBar && strengthText) {
      const width = (strength / 5) * 100;
      strengthBar.style.width = `${width}%`;
      
      let color = '#ef4444'; // red
      let text = 'Weak';
      
      if (strength >= 4) {
        color = '#22c55e'; // green
        text = 'Strong';
      } else if (strength >= 3) {
        color = '#eab308'; // yellow
        text = 'Good';
      } else if (strength >= 2) {
        color = '#f97316'; // orange
        text = 'Fair';
      }
      
      strengthBar.style.backgroundColor = color;
      strengthText.textContent = text;
    }
  }

  showValidation(input, isValid, message) {
    const validationMessage = input.closest('.form-group').querySelector('.validation-message');
    if (validationMessage) {
      validationMessage.textContent = message;
      validationMessage.style.color = isValid ? '#22c55e' : '#ef4444';
    }

    input.style.borderColor = isValid ? '#22c55e' : '#ef4444';
  }

  updateFormValidity() {
    const allInputs = this.inputTargets;
    const allValid = allInputs.every(input => {
      return input.style.borderColor === 'rgb(34, 197, 94)'; // #22c55e in RGB
    });

    this.element.dataset.formValid = allValid.toString();
  }
}
